import './../css/vendor.scss';

import tippy from 'tippy.js';
import Swal from 'sweetalert2/dist/sweetalert2.js';

window.tippy = tippy;
window.Swal = Swal;